/**
 * @file アラートの閉じるボタン
 *
 */
'use strict';

/**
 * @classname BtnAlertClose
 * @classdesc アラートの閉じるボタン
 */
export default class BtnAlertClose {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('BtnAlertClose.constructor');
		this._$e = $e;
		this._controller = controller;
		this._after_survey_id = this._$e.attr('data-after-survey-id');
		this._job_common_id = this._$e.attr('data-job-common-id');
		$e.on('click', () => this.onClick());
		// this._controller.on('onDeleteAlertComplete', () => {
		// 	console.log('onDeleteAlertComplete.constructor');
		// 	if(this._after_survey_id === this._controller._after_survey_id && this._job_common_id === this._controller._job_common_id){
		// 		this.onDeleteAlertComplete();
		// 	}
		// });
	};

	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnAlertClose
	 * @return {undefined}
	 */
	onClick() {
		console.log('BtnAlertClose.onClick');
		//this._controller.deleteAlert(this._after_survey_id, this._job_common_id);
		this._$e.closest('.block--alert').remove();
	};

	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnAlertClose
	 * @return {undefined}
	 */
	onDeleteAlertComplete() {
		console.log('onDeleteAlertComplete:exec');
		// フェードアウトだとmarginがズレるのでremoveにした。
		// 問題があったらやめる
		// this._$e.closest('.alert').fadeOut();
		this._$e.closest('.alert').remove();
	};
}
